import { SearchTermService } from './search-term.service'
import { Project } from './project'


export class SearchTerm {
  private _txt: string
  isNew: boolean

  constructor(
    private sts: SearchTermService,
    public project: Project,
    public id: string,
    text: string) {
    this.isNew = text == ''
    this.project.searchTermsMap.set(this.id, this)
    this.text = text
  }


  set text(txt) {
    this._txt = txt.replace(/\s+/g,' ').trim()
  }

  get text() {
    return this._txt
  }
}



// WEBPACK FOOTER //
// ./src/app/search-term.ts